interface CarrouselArrowIconMiddleProps {
  onClick?: (e: unknown) => void
  type: 'next' | 'prev'
}

function CarrouselArrowIconMiddle({
  onClick,
  type,
}: CarrouselArrowIconMiddleProps) {
  return (
    <div
      className={`absolute top-[50%] z-30 m-0 flex h-[16.325rem] translate-y-[-50%] items-center stroke-primary-dark ${
        type === 'next' ? '-right-2' : '-left-2'
      }  `}
      onClick={onClick}
    >
      {type === 'next' ? (
        <svg
          width='48'
          height='48'
          viewBox='0 0 48 48'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle
            cx='24'
            cy='24'
            r='23.5'
            transform='rotate(-180 24 24)'
            fill='white'
            stroke='#DCDCDC'
          />
          <path
            d='M20.9998 30.9999C20.802 30.9999 20.6087 30.9412 20.4443 30.8313C20.2799 30.7214 20.1518 30.5653 20.0761 30.3826C20.0004 30.1999 19.9806 29.9988 20.0192 29.8049C20.0578 29.6109 20.153 29.4328 20.2928 29.2929L25.5858 23.9999L20.2928 18.7069C20.1106 18.5183 20.0098 18.2657 20.0121 18.0035C20.0144 17.7413 20.1196 17.4905 20.305 17.3051C20.4904 17.1197 20.7412 17.0145 21.0034 17.0122C21.2656 17.01 21.5182 17.1108 21.7068 17.2929L27.7068 23.2929C27.8943 23.4804 27.9996 23.7348 27.9996 23.9999C27.9996 24.2651 27.8943 24.5194 27.7068 24.7069L21.7068 30.7069C21.5193 30.8945 21.265 30.9999 20.9998 30.9999Z'
            fill='#212121'
          />
        </svg>
      ) : (
        <svg
          width='48'
          height='48'
          viewBox='0 0 48 48'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='24' cy='24' r='23.5' fill='white' stroke='#DCDCDC' />
          <path
            d='M27.0002 17.0001C27.198 17.0001 27.3913 17.0588 27.5557 17.1687C27.7201 17.2786 27.8482 17.4347 27.9239 17.6174C27.9996 17.8001 28.0194 18.0012 27.9808 18.1951C27.9422 18.3891 27.847 18.5672 27.7072 18.7071L22.4142 24.0001L27.7072 29.2931C27.8894 29.4817 27.9902 29.7343 27.9879 29.9965C27.9856 30.2587 27.8804 30.5095 27.695 30.6949C27.5096 30.8803 27.2588 30.9855 26.9966 30.9878C26.7344 30.99 26.4818 30.8892 26.2932 30.7071L20.2932 24.7071C20.1057 24.5196 20.0004 24.2652 20.0004 24.0001C20.0004 23.7349 20.1057 23.4806 20.2932 23.2931L26.2932 17.2931C26.4807 17.1055 26.735 17.0001 27.0002 17.0001Z'
            fill='#212121'
          />
        </svg>
      )}
    </div>
  )
}

export default CarrouselArrowIconMiddle
